import React, { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ArrowBackIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Header } from '../../../components/header/header';
import Strings from '../../../i18n';
import { TooltipStyled } from '../../locations/locationStyles';
import { ButtonIconStyled, TitleStyled } from '../../devices/devicesStyles';

import { PartNumberTemplate } from '../../../templates/manufacture/partNumberTemplate/partNumberTemplate';
import { RightSideBar } from '../../../components/layout/rightSideBar/rightSideBar';
import { viewRightSideBarEnum } from '../../../constants/sidebarEnums';
import { EditPartNumberSideBar } from '../../../templates/manufacture/partNumberTemplate/editPartNumberTemplate/editPartNumberTemplate';
import { CreatePartNumberSideBar } from '../../../templates/manufacture/partNumberTemplate/createPartNumberSideBar/createPartNumberSideBar';
import { ContainerStyled } from '../../../components/layout/main/mainStyles';
import { useGetPartNumberMutation } from '../../../services/manufacture/manufactureService';

export const ManufacturingPartNumberView = () => {
  const navigate = useNavigate();
  const [openSideBarFor, setOpenSideBarFor] = useState<number | null>(null);
  const [openSideBar, setOpenSideBar] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);

  const [getPartNumber, { isSuccess, data, isLoading }] =
    useGetPartNumberMutation();

  const reloadTable = () => {
    getPartNumber(null);
    setSelectedItems([]);
    return {};
  };

  useEffect(() => {
    reloadTable();
  }, []);

  const handleRightSideBarMethod = (method: number) => {
    setOpenSideBarFor(method);
  };

  const switchComponentToShowRightSideBar = () => {
    switch (openSideBarFor) {
      case viewRightSideBarEnum.createPartNumber:
        return (
          <CreatePartNumberSideBar
            reloadTable={reloadTable}
            setOpenSideBar={setOpenSideBar}
            openRightSideBarForMethod={handleRightSideBarMethod}
          />
        );
      case viewRightSideBarEnum.singlePartNumber:
        return (
          <EditPartNumberSideBar
            partNumber={selectedItems[0]}
            reloadTable={reloadTable}
            setOpenSideBar={setOpenSideBar}
            setUsersSelected={setSelectedItems}
            openRightSideBarForMethod={handleRightSideBarMethod}
          />
        );
      case viewRightSideBarEnum.multipleUserActivation:
      default:
        return null;
    }
  };

  useEffect(() => {
    if (selectedItems.length === 1) {
      setOpenSideBar(true);
      setOpenSideBarFor(viewRightSideBarEnum.singlePartNumber);
    } else if (selectedItems.length > 1) {
      setOpenSideBar(true);
      setOpenSideBarFor(viewRightSideBarEnum.multipleUserActivation);
    } else {
      setOpenSideBar(false);
    }
  }, [selectedItems]);

  return (
    <>
      <Header>
        <ContainerStyled>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <TitleStyled align="center">
                {Strings.manufacture.partNumber.title}
              </TitleStyled>
            </div>
            <div className="col-4 text-right">
              <Tooltip
                title={Strings.locations.addLocation}
                placement="top"
                arrow
                componentsProps={TooltipStyled}
              >
                <ButtonIconStyled
                  size="small"
                  onClick={() => {
                    setOpenSideBar(true);
                    setOpenSideBarFor(viewRightSideBarEnum.createPartNumber);
                  }}
                >
                  <AddCircleOutlineIcon />
                </ButtonIconStyled>
              </Tooltip>
            </div>
          </div>
        </ContainerStyled>
      </Header>
      <PartNumberTemplate
        isLoading={isLoading}
        isSuccess={isSuccess}
        allPartNumber={data ?? []}
        openedSideBar={openSideBar}
        setOpenSideBar={setOpenSideBar}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />
      <RightSideBar
        open={openSideBar}
        onMenuClose={() => {
          setOpenSideBar(false);
        }}
      >
        {switchComponentToShowRightSideBar()}
      </RightSideBar>
    </>
  );
};
